import { S3_BASE_URL } from '../config/constants';

/**
 * Constructs the proper URL for uploaded images
 * @param imagePath - The image path from the database (could be full URL or S3 slug)
 * @returns The full URL to access the image
 */
export function getImageUrl(imagePath: string | null | undefined): string {
  if (!imagePath) return '';
  
  // If it's already a full URL (starts with http/https), return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If it's a slug string, concatenate with S3 base URL
  return S3_BASE_URL + imagePath;
}